<template>
  <div class="tenant-account-box tenant_account_wrap">
    <!-- 左侧 -->
    <div class="tenant-account-left">
      <div style="padding: 16px 16px 8px 16px">
        <div class="tenant-name-box">
          <span>企业开户</span>
          <i class="el-icon-circle-plus"></i>
        </div>
        <el-select class="w100f mt12" v-model="value" placeholder="请选择">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
        <el-input class="w100f mt8 mb10" v-model="input" placeholder="请输入内容"
          ><i slot="prefix" class="el-input__icon el-icon-search"></i
        ></el-input>
      </div>
      <!-- 企业列表 -->
      <div class="tenant-list" v-for="(item, index) in tenantList" :key="index">
        <div class="tenant-list-left">{{ item.tenantName }}</div>
        <div :class="getTenantStateClass(item.state)">{{ item.state | tenantAccountState }}</div>
      </div>
    </div>
    <!-- 右侧 -->
    <div class="tenant-account-right">
      <!-- 企业名称 -->
      <div class="tenant-inform-box">
        <div class="tenant-inform-left">
          <img src="../../assets/images/no_tenant.png" alt="" />
          <div class="tenant-inform-title">
            <h1>武汉链想科技有限公司 <span>编辑</span></h1>
            <p>暂无简称</p>
          </div>
        </div>
        <div class="mt24 mr24 fontC-4fa1a4 c-pointer">分配运营方</div>
      </div>
      <!-- 开户步骤 -->
      <h2 class="tenant-step-title">企业开户分为以下 6个步骤：</h2>
      <p class="tenant-step-list" v-for="(item, index) in stepList" :key="index">
        <span class="mr12">{{ item.title }}</span
        ><i class="el-icon-success"></i><span class="fontC-999 mr12">已新增{{ item.num }}个{{ item.stepName }}</span
        ><span class="fontC-4fa1a4 c-pointer">查看详情/去新增>></span>
      </p>
      <h2 class="tenant-step-title">流程审批</h2>
      <p class="fontC-666 t-left c-pointer ml30">添加审批人：<span class="fontC-4fa1a4"><i class="el-icon-circle-plus mr5"></i>添加审批人</span></p>
      <!-- 流程审批 -->
      <div class="tenant-flow-box">
        <div class="tenant-flow-left">
          <span></span>
          <div class="tenant-flow-line"></div>
        </div>
        <div class="tenant-flow-right">
          <div class="tenant-flow-name"><span>审批人：张三-岗位信息</span><span :class="getTenantFlowStateClass(1)">待审批</span></div>
          <div class="tenant-flow-suggest">审批备注占字符审批备注占字符审批备注占字符审批备注占字符</div>
          <p>2022-12-12 10:10:10</p>
        </div>
      </div>
      <!-- 底部按钮 -->
      <div class="tenant-submit-btn">
        <el-button  size="medium" type="borderBlack" class="font-S12">取消</el-button>
        <el-button  size="medium" type="borderGreen" class="font-S12">存为草稿</el-button>
        <el-button  size="medium" type="importNew" >重新提交</el-button>
        <el-button  size="medium" type="borderBlack" class="font-S12">撤销</el-button>
      </div>
    </div>
     
  </div>
</template>
<script>
export default {
  data() {
    return {
      options: [
        {
          value: '',
          label: '全部',
        },
        {
          value: '2',
          label: '已通过',
        },
        {
          value: '3',
          label: '待提交',
        },
        {
          value: '4',
          label: '已驳回',
        },
      ],
      value: '',
      input: '',
      tenantList: [
        { tenantName: '公司一', state: 1 },
        { tenantName: '公司二', state: 2 },
        { tenantName: '公司三', state: 3 },
      ],
      stepList: [
        { title: '1、添加部门', num: 2, stepName: '部门', url: '/drugBusinessUnit' },
        { title: '2、添加组织', num: 2, stepName: '部门', url: '/drugOrganizationalStructure' },
        { title: '3、添加岗位', num: 3, stepName: '部门', url: '/drugPostManagement' },
        { title: '4、添加角色信息', num: 2, stepName: '部门', url: '/drugRoleManagement' },
        { title: '5、添加销售区域', num: 2, stepName: '部门', url: '/drugSalesArea' },
        { title: '6、添加人员信息', num: 2, stepName: '部门', url: '/drugManagementPersonnel' },
      ],
    };
  },
  methods: {
    //左侧企业状态
    getTenantStateClass(state) {
      switch (state) {
        case 1:
          return 'tenant-list-right';
          break;
        case 2:
          return 'tenant-state-pass tenant-list-right';
          break;
        case 3:
          return 'tenant-state-reject tenant-list-right';
          break;
      }
    },
    //审批节点状态
    getTenantFlowStateClass(state) {
      switch (state) {
        case 1:
          return 'tenant-state tenant-state-handle';
          break;
        case 2:
          return 'tenant-state tenant-state-pass';
          break;
        case 3:
          return 'tenant-state tenant-state-reject';
          break;
      }
    },
    
  },
};
</script>
<style scoped>
/* 最外层区域 */
.tenant-account-box {
  min-height: calc(100vh - 90px);
  display: flex;
  justify-content: space-between;
  background: #fff;
  border-top: 1px solid #eaeaea;
}
/* 左侧区域 */
.tenant-account-left {
  width: 21%;
  box-sizing: border-box;
  border-right: 1px solid #eaeaea;
}
.tenant-account-right {
  position: relative;
  flex: 1;
}
.tenant-name-box {
  display: flex;
  justify-content: space-between;
}
.tenant-name-box span {
  font-size: 16px;
  color: #323233;
}
.tenant-name-box i {
  font-size: 21px;
  color: #4fa1a4;
  cursor: pointer;
}
.tenant-list {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 0 16px;
  color: #42434f;
  box-sizing: border-box;
}
.tenant-list:hover {
  background: #ebf6f7;
}
.tenant-list-left {
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
}
.tenant-list-right {
  width: 46px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #999;
  text-align: center;
  background: #F2F2F2;
  border: 1px solid rgba(231,231,231,1);
  border-radius: 2px;
  box-sizing: border-box;
}
/* 通过 */
.tenant-state-pass {
  color: #4fa1a4;
  background: #ebf6f7;
  border: 1px solid rgba(211, 236, 237, 1);
}
/* 驳回 */
.tenant-state-reject {
  color: #fb2323;
  background: #fff2f4;
  border: 1px solid rgba(255, 219, 224, 1);
}
/* 右侧区域 */
.tenant-account-right {
  padding-bottom: 100px;
  box-sizing: border-box;
}
/* 右方步骤 */
.tenant-inform-box {
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eaeaea;
}

.tenant-inform-left {
  display: flex;
}
.tenant-inform-left img {
  width: 72px;
  height: 72px;
  margin: 24px 24px 32px 32px;
}
.tenant-inform-title h1 {
  font-size: 18px;
  color: #212121;
  line-height: 27px;
  margin-bottom: 4px;
}
.tenant-inform-title p {
  font-size: 14px;
  color: #999999;
  text-align: left;
  margin: 0;
}
.tenant-inform-title h1 span {
  color: #4fa1a4;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  margin-left: 12px;
}
.tenant-step-title {
  font-size: 16px;
  color: #212121;
  text-align: left;
  font-weight: 400;
  padding-left: 16px;
  margin-bottom: 24px;
}
.tenant-step-list {
  margin: 0 16px 32px 32px;
  color: #212121;
  text-align: left;
}
.tenant-step-list .el-icon-success {
  color: #4fa1a4;
  margin-right: 8px;
}
/* 审批节点 */
.tenant-flow-box{
  width: 370px;
  display: flex;
  text-align: left;
  margin-left: 32px;
}
.tenant-flow-left{
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-right: 16px;
}
.tenant-flow-left span{
  display: block;
  width: 12px;
  height: 12px;
  background: #4fa1a4;
  border-radius: 50%;
  margin-top: 8px;
}
.tenant-flow-line{
  width: 2px;
  height: 74px;
  margin-top: 5px;
  background: #D9D9D9;
}
.tenant-flow-name{
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #212121;
  line-height: 21px;
  font-weight: 600;
  margin-bottom: 8px;
}
.tenant-flow-suggest{
  color: #666;
}
.tenant-flow-box p{
  color: #999999;
}
.tenant-submit-btn{
  width: 100%;
  height: 63px;
  position: absolute;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #D9D9D9;
}
</style>
